import { AppPalette } from '../../colors'

export const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      height: '42px',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      ['&:not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline']: {
        borderColor: 'red'
      },
      '& fieldset': {
        borderColor: AppPalette.BORDER.darker,
        backgroundColor: AppPalette.NEUTRAL.darker
      },
      '.MuiInputBase-input ': {
        color: AppPalette.YELLOW.main
      }
    },
    notchedOutline: {
      borderColor: '#D2D2D2'
    },
    input: {
      zIndex: 1,
      padding: '12px 16px',
      '&::placeholder': {
        color: '#999999'
      }
    }
  }
  // defaultProps: {
  //   color: 'secondary'
  // }
}
